import { GroupWrappedIcon } from '../../../../../assets/svg/group-wrapped';
import { StonksWrappedIcon } from '../../../../../assets/svg/stonks-wrapped';
import { DashboardCardProps } from '../dashboard-components/dashboard-cards/dashboard-card/dashboard-card';

export const totalOrdersDefaults: DashboardCardProps = {
  content: '0 шт',
  title: 'Всего заказов',
  icon: <StonksWrappedIcon />,
};

export const bestWaiterDefaults: DashboardCardProps = {
  title: 'Лучший официант',
  content: '',
  icon: <GroupWrappedIcon />,
  delta: 0,
};

// export const workMenuTimeDefaults: DashboardCardProps = {
//   content: 'Недоступно',
//   title: 'Время работы с меню',
//   icon: <TimeWrappedIcon />,
//   delta: 0,
// };

// export const viewMenuTimeDefaults: DashboardCardProps = {
//   content: 'Недоступно',
//   title: 'Просмотров меню',
//   icon: <MenuWrappedIcon />,
//   delta: 0,
// };
